import { push } from 'connected-react-router';
import { generatePath } from 'react-router';
import {
  call,
  put,
} from 'redux-saga/effects';
import { rememberUtm } from '../actions/navigation';
import {
  utm,
  validUTM,
} from '../utils/url-parser';
import Routes from '../routes';

/*
 * This function hydrates the state/storage from special URL paramaters
 *
 * NOTE : do not handle confirmationToken here
 *   it is tightly coupled with user bootstrapping and needs to be executed
 *   at a very specific time during sagas initialization
 */
export function* hydrateFromUrl() {
  try {
    if(validUTM) {
      yield call(handleUtm, utm);
    }
  } catch(error) {
    console.log(error); // eslint-disable-line no-console
    window.Rollbar && window.Rollbar.error('Error while attempting to hydrate from URL params & hash', error);
  }
}

/**
 * Handle old referral link to ensure go to signup
 * @deprecated
 */
export function* handleFollowingReferralInvitation() {
  yield put(push({
    pathname: generatePath(Routes.signupView, { flow: 'students' }),
  }));
}

function* handleUtm(utm){
  yield put(rememberUtm(utm));
}
